<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <!--
      <template v-slot:activator="{ on }">
        <v-btn text v-on="on">Facebook</v-btn>
      </template>
      -->
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Facebook</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn dark text @click="dialog = false">Fechar</v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container>
        <v-card :loading="loading" class="mx-auto my-12" :max-width="width">
          <iframe
            :src="facebooklink"
            :width="width"
            height="800"
            style="border:none;overflow:hidden"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
          ></iframe>
        </v-card>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      loading: false,
      facebooklink:
        "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fviolent-noise-blog&tabs=timeline&width=500&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId",
      width: 500
    };
  },
  created: function() {
    if (window.innerHeight <= 500) {
      this.width = window.innerHeight - 10;

      this.facebooklink =
        "https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fviolent-noise-blog&tabs=timeline&width=" +
        this.width +
        "&height=800&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId";
    }
  },
  watch: {
    IsFacebook(val) {
      if (!val) return;

      if (val == true) {
        this.dialog = true;

        this.$store.commit("setIsFacebook", false);
      }
    }
  },
  computed: mapState([
    // map this.count to store.state.count
    "IsFacebook",
    "IsMobile"
  ])
};
</script>

<style></style>
